<template>
  <div id="header" class="parallaxbg">
    <password-reset
      :errorMessage="errorMessage"
      :resetPasswordResponse="resetPasswordResponse"
      @changePassword="changePassword"
      @viewLoginScreen="viewLoginScreen" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { userNotifiers } from 'pando-constants';
import PasswordReset from '@common/components/PasswordReset';

export default {
  name: 'ResetPassword',
  data() {
    return {
      resetPasswordResponse: false,
      errorMessage: null,
      userNotifiers,
    };
  },
  components: {
    PasswordReset,
  },
  computed: {
    ...mapGetters({
      currUser: 'app/currentUser',
    }),
  },
  mounted() {
    const { resetPasswordReason } = this.$route.params;
    if (resetPasswordReason && resetPasswordReason === userNotifiers.PASSWORD_EXPIRED) {
      this.$errorMessage({ message: resetPasswordReason });
    }
  },
  methods: {
    ...mapActions({
      logout: 'app/logout',
      updateProfilePassword: 'app/changeProfilePassword',
    }),
    async changePassword(data) {
      try {
        const result = await this.updateProfilePassword({ data, userId: this.currUser.id });
        if (result && result.data) {
          this.logout({ noRedirect: true });
          localStorage.setItem('tsm-transporter-token', '');
          this.resetPasswordResponse = true;
          this.errorMessage = null;
        } else if (result && result.errMsg) {
          this.$errorMessage({ message: result.errMsg });
        }
        return { result };
      } catch (err) {
        throw (err);
      }
    },
    viewLoginScreen() {
      this.logout({ noRedirect: true });
      this.$store.commit('app/SET_FILTER_VISIBILITY', false);
      localStorage.setItem('tsm-transporter-token', '');
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
